import React from 'react';

import logo from '../../../assets/wedo3.svg';
import { Container, Content, Wrapper, ContentImage } from './styles';

export default function AuthLayout({
  children,
}: JSX.ElementChildrenAttribute): any {
  return (
    <Container>
      <Wrapper>
        <Content>{children}</Content>
        <ContentImage>
          <img
            src={logo}
            alt="Wedo - Afferolab"
            style={{ width: '126px', height: '66px', marginLeft: '6px' }}
          />
          <p>
            A sua plataforma para gestão de projetos, logística e muito mais.
          </p>
        </ContentImage>
      </Wrapper>
    </Container>
  );
}
